import { motion } from 'framer-motion';
import { BadgeCheck } from 'lucide-react';

const PricingCard = ({ plan, isAnnual, currentSubs, onUpgrade, isPopular }) => {
  const isCurrentPlan = currentSubs?.subscriptionTypeId === plan.id;
  const isFreemium = plan.name === 'Freemium';
  const isBasicPlan = plan.name === 'Basic';
  const isUserRegular = currentSubs?.packageName === 'Regular';
  const Features = JSON.parse(plan.features);

  return (
    <motion.div
      whileHover={{ y: -8, scale: 1.02 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`relative overflow-hidden rounded-2xl h-[700px] ${
        isCurrentPlan
          ? 'bg-gradient-to-br from-booker via-teal-600 to-teal-700 shadow-xl shadow-black/20'
          : 'bg-white shadow-lg hover:shadow-xl'
      }`}>
      {/* Popular Badge */}
      {isPopular && (
        <div className='absolute -right-12 top-8 rotate-45 bg-gradient-to-r from-teal-400 to-teal-500 px-12 py-1 text-sm font-semibold text-white shadow-lg'>
          Most Popular
        </div>
      )}

      <div className='p-8 h-full flex flex-col'>
        {/* Plan Header */}
        <div className='mb-8'>
          <h3
            className={`text-3xl font-hurmeBold ${
              isCurrentPlan ? 'text-white' : 'text-booker'
            }
            ${isFreemium ? 'underline' : ''}
            `}>
            {plan.name}
          </h3>
          <div className='mt-4 flex items-baseline gap-2'>
            <span
              className={`text-5xl font-bold ${
                isCurrentPlan ? 'text-white' : 'text-gray-900'
              }`}>
              $
              {isFreemium
                ? isAnnual //Hol lal free
                  ? plan?.yearlyCost?.toFixed(2)
                  : plan?.cost?.toFixed(2)
                : isAnnual // ho la kelshi 8er l free X
                ? (plan?.yearlyCost - 0.01).toFixed(2)
                : (plan?.cost - 0.01).toFixed(2)}
            </span>
            {isFreemium ? (
              <span
                className={`${
                  isCurrentPlan ? 'text-teal-100' : 'text-gray-500'
                }`}>
                / Lifetime
              </span>
            ) : (
              <span
                className={`${
                  isCurrentPlan ? 'text-teal-100' : 'text-gray-500'
                }`}>
                / {isAnnual ? 'Year' : 'Month'}
              </span>
            )}
            {/* <span
              className={`${
                isCurrentPlan ? 'text-teal-100' : 'text-gray-500'
              }`}>
              / {isAnnual ? 'Year' : 'Month'}
            </span> */}
          </div>
          {isAnnual && !isFreemium && (
            <span
              className={`mt-2 inline-block rounded-full ${
                isCurrentPlan
                  ? 'bg-teal-400 text-white'
                  : 'bg-teal-100 text-teal-800'
              } px-3 py-1 text-sm font-medium`}>
              Save 20% yearly
            </span>
          )}
          {isAnnual && isFreemium && (
            <span
              className={`mt-2 inline-block rounded-full ${
                isCurrentPlan && isFreemium && 'text-transparent'
              } 
              px-3 py-1 text-sm font-medium`}></span>
          )}
        </div>

        {/* Features */}
        <div
          className={`space-y-4 font-hurmeBold flex-grow ${
            isCurrentPlan ? 'text-white' : 'text-gray-600'
          }`}>
          {Features?.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className={`flex items-center gap-3 rounded-lg p-2 transition-colors duration-200 
                `}>
              <span
                className={`flex h-8 w-8 items-center justify-center rounded-full`}>
                {/* <span className='text-xl'>{feature.icon}</span> */}
                <BadgeCheck
                  className={`${isCurrentPlan ? 'text-white' : 'text-booker'}`}
                />
              </span>
              <span className='font-hurme'>{feature.description}</span>
            </motion.div>
          ))}
        </div>

        {/* Button Container - add min-height to maintain spacing */}
        <div className='h-[72px] flex items-end'>
          {(!isFreemium || isCurrentPlan) &&
            !(isBasicPlan && isUserRegular) && (
              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                disabled={isCurrentPlan}
                onClick={() => onUpgrade(plan)}
                className={`w-full rounded-xl px-6 py-4 text-center font-semibold shadow-lg transition-all ${
                  isCurrentPlan
                    ? 'cursor-not-allowed bg-white/20 text-white/60'
                    : isPopular
                    ? 'bg-gradient-to-r from-teal-600 to-teal-700 text-white hover:from-teal-700 hover:to-teal-600'
                    : 'bg-booker text-white'
                }`}>
                {isCurrentPlan ? (
                  'Current Plan'
                ) : (
                  <span className='flex items-center justify-center gap-2'>
                    <span>Upgrade To {plan.name}</span>
                  </span>
                )}
              </motion.button>
            )}
        </div>
      </div>
    </motion.div>
  );
};

export default PricingCard;
